import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  HasUserAEuropeanBankAccount = 'hasUserAEuropeanBankAccount',
}

const guards: MachineGuards<Model, Guard> = {
  hasUserAEuropeanBankAccount: ({ getModuleData }) => {
    const capitalDeposit = getModuleData().data.viewer.company?.capitalDeposit;

    if (!capitalDeposit) {
      throw Error('capitalDeposit must be defined');
    }

    return capitalDeposit.hasEuropeanBankAccount === true;
  },
};

export default guards;
